import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import {
  MapContainer,
  Marker,
  Polyline,
  TileLayer,
  useMap,
} from 'react-leaflet';
import ExcelJS from 'exceljs';

import {
  Pagination,
  Stack,
  TextField,
  CircularProgress,
  Button,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { InputAdornment, Typography, IconButton } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';

import DataGrid from '../../../components/Datagrid/Datagrid';
import TPieChart from './components/TPieChart';
import { columns as Columns } from './constants/table_columns_data';
import service from '../VoyageReports/service';
import { formatDateWithTimeZoneForSearch } from '../../../utils/dateFormats';
import FullLayout from '../../../layouts/fullLayout';
import StartIcon from '../../../assets/images/start-Icon.png';
import EndIcon from '../../../assets/images/finish-Icon.png';
import { theme } from '../../../theme/theme';
import { useBoundStore } from '../../../stores';

import moment from 'moment';
import { saveAs } from 'file-saver';

const oneDayInMillis = 24 * 60 * 60 * 1000;
const initialValue = {
  t0: new Date(new Date().getTime() - oneDayInMillis).getTime(),
  t1: Date.now(),
};

import Number from '../../../components/CustomNumber/Number';

function CardEvents() {
  const textPool = useBoundStore((store) => store.textPool);
  const toggleLeftDrawerOpen = useBoundStore((state) => state.toggleLeftDrawer);
  const location = useLocation();
  const [sortModel, setSortModel] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [allTransportation, setAllTransportation] = useState([]);
  const [allTransportationForExcel, setAllTransportationForExcel] = useState(
    [],
  );
  const [allCardEvents, setAllCardEvents] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [filterDataInput, setFilterDataInput] = useState('');
  const [formDateData, setFormDateData] = useState(initialValue);
  const [transportationData, setTransportationData] = useState(null);
  const [locations, setLocations] = useState([]);

  function paginationChange(_, e_page) {
    setPage(e_page - 1);
  }

  const handleClick = async (data) => {
    const result = await service.findAllByMCodeAndMtId(data.id);
    const response = result?.data?.data;
    setTransportationData(response);
    setLocations(response.map((item) => [item.coordinate.split(',')]));
  };

  const handleDetail = async (data) => {
    console.log(data);
    toggleLeftDrawerOpen();
  };

  const columns = Columns({ handleClick, handleDetail });

  const handleChangeFilterDataInput = async (event) => {
    setFilterDataInput(event.target.value);

    await getAllTransportationData();
  };
  let promisesMotion = [];
  async function downloadExcellAllTransportation(data) {
    const wb = new ExcelJS.Workbook();
    wb.creator = textPool['Terra Yazılım'];
    wb.created = new Date();
    wb.modified = new Date();
    const ws = wb.addWorksheet();
    ws.columns = [
      { header: textPool['Hareket Adı'], key: 'title', width: 24 },
      { header: textPool['Hareket Durumu'], key: 'status', width: 24 },
      { header: textPool['Sürücü Adı'], key: 'driver', width: 30 },
      { header: textPool['Araç Plakası'], key: 'vehicle', width: 12 },
      { header: textPool['Başlangıç Noktası'], key: 'startPoint', width: 24 },
      { header: textPool['Bitiş Noktası'], key: 'endPoint', width: 24 },
      { header: textPool['Toplam Süre'], key: 'totalDuration', width: 24 },
      { header: textPool['Toplam Mesafe'], key: 'totalDistance', width: 24 },
      { header: textPool['Başlangıç Tarihi'], key: 'beginDate', width: 20 },
      { header: textPool['Bitiş Tarihi'], key: 'endDate', width: 20 },
    ];

    data.forEach((item, index, arr) => {
      const {
        id,
        transportation: {
          content,
          title,
          status,
          beginDate,
          endDate,
          driver,
          vehicle,
          totalDistance,
          totalDuration,
          startPoint,
          endPoint,
        },
      } = item;
      let newStatus = '';
      if (status === 'COMPLETED') {
        newStatus = textPool['TAMAMLANDI'];
      } else {
        newStatus = textPool['AKTİF'];
      }

      Promise.all(promisesMotion).then(() => {
        ws.addRow({
          title: `${content || '-'}`,
          status: `${newStatus}`,
          driver: `${driver?.id || '-'}`,
          vehicle: `${vehicle?.id || '-'}`,
          startPoint: `${startPoint || '-'}`,
          endPoint: `${endPoint || '-'}`,
          totalDuration: `${totalDuration || '-'}`,
          totalDistance: `${totalDistance || '-'}`,
          beginDate: `${new Date(beginDate).toLocaleString('tr')}`,
          endDate: `${endDate ? new Date(endDate).toLocaleString('tr') : '-'}`,
        });

        if (!arr[index + 1]) {
          saveExcel();
        }
      });
    });

    async function saveExcel() {
      const buf = await wb.xlsx.writeBuffer();
      saveAs(
        new Blob([buf]),
        textPool['Hareket Dökümü'] + ' ' + `${new Date()}.xlsx`,
      );
    }
  }

  const getAllCardEventData = async () => {
    setIsLoading(true);

    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;
    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 9999999,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };

    const result = await service.getCardEventswithSearch(params);
    const data = result?.data?.data;
    setAllCardEvents(data);
    setIsLoading(false);
  };

  const getAllTransportationDataForDashboard = async () => {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;
    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 9999999,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };

    const result = await service.getAllTransportationWithSearch(params);
    const data = result?.data?.data;
    setAllTransportationForExcel(data);
    const uniqueVehicle = [];
    data?.forEach((item) => {
      if (!uniqueVehicle.includes(item?.schema?.vehicle?.id)) {
        uniqueVehicle.push(item?.schema?.vehicle?.id);
      }
    });
    setVehicles(uniqueVehicle);
    setIsLoading(false);
  };

  const getAllTransportationDataForExcel = async () => {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;
    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 9999999,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };

    const result = await service.getAllTransportationWithSearch(params);
    const data = result?.data?.data;
    setAllTransportationForExcel(data);
    setIsLoading(false);
    await downloadExcellAllTransportation(result?.data?.data);
  };

  const getAllTransportationData = async () => {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0 ? sortModel[0] : { field: 'id', sort: 'desc' };
    const { t0, t1 } = formDateData;

    const params = {
      query: encodeURI(filterDataInput),
      ignoreCase: true,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
      t0: formatDateWithTimeZoneForSearch(t0),
      t1: formatDateWithTimeZoneForSearch(t1),
    };
    const result = await service.getAllTransportationWithSearch(params);
    const data = result?.data?.data;
    const properties = result?.data?.properties;
    setCount(properties?.totalPages);
    setAllTransportation(data);
    setIsLoading(false);
  };

  const handleFormData = (value, key) => {
    const newFormData = { ...formDateData };
    newFormData[key] = value;
    setFormDateData(newFormData);
  };

  const findCompleteRate = (data) => {
    const completeRate = data.filter(
      (item) => item?.transportation?.status === 'COMPLETED',
    ).length;
    return completeRate / data.length;
  };

  const findActiveTransportation = (data) => {
    const completed = data.filter(
      (item) => item?.transportation?.status === 'COMPLETED',
    ).length;
    return completed;
  };

  const findSuccessRate = (data) => {
    const successRate = data.filter(
      (item) => item?.transportation?.succeeded === true,
    ).length;
    return successRate / data.length;
  };

  const findSucceededTransportation = (data) => {
    const succeeded = data.filter(
      (item) => item?.transportation?.succeeded === true,
    ).length;
    return succeeded;
  };

  const Centerer = () => {
    const map = useMap();
    useEffect(() => {
      if (transportationData && transportationData.length > 0) {
        const startPoint = transportationData[0].coordinate.split(',');
        const endPoint =
          transportationData[transportationData.length - 1].coordinate.split(
            ',',
          );
        const lat = (parseFloat(startPoint[0]) + parseFloat(endPoint[0])) / 2;
        const lon = (parseFloat(startPoint[1]) + parseFloat(endPoint[1])) / 2;

        map.flyTo([lat, lon], 12, {
          duration: 0.6,
        });
      }
    }, [transportationData, map]);

    return null;
  };

  useEffect(() => {
    getAllTransportationData();
    getAllTransportationDataForDashboard();
    getAllCardEventData();
  }, [page, /* filterDataInput, */ sortModel, formDateData, location]);

  return (
    <FullLayout>
      <div className=" flex flex-col justify-center items-center p-2">
        <div className="w-max max-sm:w-full h-full flex flex-col justify-center items-center">
          <>
            <div className="bg-white rounded-xl shadow-xl max-sm:w-full w-full h-full p-3 m-3 max-sm:m-0 max-sm:p-1 ">
              <div className="text-left max-sm:text-center max-sm:text-sm w-full p-3 m-3 max-sm:m-0 max-sm:p-3 text-xl flex justify-center items-center">
                <div className="flex justify-center items-center p-3 m-3 text-center shadow-lg rounded-lg">
                  {moment(formDateData.t0).format('Do MMMM YYYY')} <br />
                  {moment(formDateData.t0).format('HH:mm')}
                </div>
                <div className="flex justify-center items-center p-3 m-3 text-center w-1/2 max-sm:w-1/12">
                  <hr className="border-t-[4px] w-full border-black  border-dotted " />
                </div>
                <div className="flex justify-center items-center p-3 m-3 text-center shadow-lg rounded-lg">
                  {moment(formDateData.t1).format('Do MMMM YYYY')} <br />
                  {moment(formDateData.t1).format('HH:mm')}
                </div>
              </div>
              <div className="flex justify-evenly max-sm:flex-wrap items-center p-3 m-3 max-sm:m-0 max-sm:p-3 w-full">
                <div className="flex flex-col max-sm:w-max w-1/2">
                  <div className="flex max-sm:flex-wrap p-2 m-2 gap-2 ">
                    <div className="w-full flex max-sm:flex-wrap flex-col justify-center items-center p-2 m-2 gap-2">
                      <div className=" flex bg-blue-50 rounded-md p-2 w-64">
                        <div className="rounded-md shadow-md m-2 w-12  h-12 bg-[#E8E7FD] flex justify-center items-center">
                          <MATERIEL_ICONS.DirectionsCar
                            style={{ color: '#9E97F5' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Toplam Araç Sayısı</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number n={vehicles?.length} />
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="flex bg-cyan-100 rounded-md p-2 w-64">
                        <div className="rounded-md shadow-md m-2 w-12 h-12 bg-[#b8f9fc] flex justify-center items-center">
                          <MATERIEL_ICONS.AirlineStops
                            style={{ color: '#02cdfa' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Toplam Görev Sayısı</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number n={allTransportationForExcel?.length} />
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="w-full flex flex-col max-sm:flex-wrap justify-center items-center p-2 m-2 gap-2">
                      <div className="flex bg-orange-50 rounded-md p-2 w-64">
                        <div className="rounded-md shadow-md m-2 w-12 h-12 bg-[#fff1b4] flex justify-center items-center">
                          <MATERIEL_ICONS.DoubleArrow
                            style={{ color: '#FFA85A' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Aktif Görev Sayısı</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number
                                n={
                                  allTransportationForExcel.length -
                                  findActiveTransportation(
                                    allTransportationForExcel,
                                  )
                                }
                              />
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="flex bg-green-50 rounded-md p-2 w-64">
                        <div className="rounded-md shadow-md m-2 w-12  h-12 bg-[#bdffc7] flex justify-center items-center">
                          <MATERIEL_ICONS.CheckCircle
                            style={{ color: '#08c949' }}
                          />
                        </div>
                        <div className="flex flex-col justify-start">
                          <span className="p-1 ">Bitirilen Görev Sayısı</span>
                          <span className="p-1 font-bold text-left">
                            {isLoading ? (
                              <CircularProgress
                                style={{ width: '20px', height: '20px' }}
                              />
                            ) : (
                              <Number
                                n={findActiveTransportation(
                                  allTransportationForExcel,
                                )}
                              />
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex max-sm:w-max max-sm:flex-wrap justify-evenly items-center w-1/2">
                  <div className=" w-[300px] flex justify-center items-center">
                    <div>
                      <TPieChart
                        text="Görevlerin Bitirilme Oranı"
                        rate={
                          findCompleteRate(allTransportationForExcel)
                            ? findCompleteRate(
                                allTransportationForExcel,
                              ).toFixed(2)
                            : 0
                        }
                        subtitle={
                          findCompleteRate(allTransportationForExcel)
                            ? `${(
                                findCompleteRate(allTransportationForExcel) *
                                100
                              ).toFixed(2)}%`
                            : '0%'
                        }
                        bgColor={['#ffb300', '#ffe7b0']}
                      />
                    </div>
                  </div>
                  <div className=" w-[300px] flex justify-center items-center">
                    <div>
                      <TPieChart
                        text="Görevlerin Başarı Oranı"
                        rate={
                          findSuccessRate(allTransportationForExcel)
                            ? findSuccessRate(
                                allTransportationForExcel,
                              ).toFixed(2)
                            : 0
                        }
                        subtitle={
                          findSuccessRate(allTransportationForExcel)
                            ? `${(
                                findSuccessRate(allTransportationForExcel) * 100
                              ).toFixed(2)}%`
                            : '0%'
                        }
                        bgColor={['green', 'rgba(0,128,0,0.3)']}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex max-sm:flex-col justify-center items-center w-full h-full gap-5 mb-3 p-3 m-3 ">
              <div className="my-5">
                <span className="text-lg sm:text-2xl max-sm:text-center py-3 px-2 mx-3 my-2">
                  {textPool['Görev Raporları']}
                </span>
              </div>
              <TextField
                sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                placeholder={textPool['Arama']}
                size="small"
                onChange={handleChangeFilterDataInput}
                value={filterDataInput}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MATERIEL_ICONS.Search />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: '8px',
                  },
                }}
              />
              <DateTimePicker
                sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                label={textPool['Başlangıç Tarihi']}
                ampm={false}
                slotProps={{ textField: { size: 'small' } }}
                inputFormat="dd/MM/yyyy hh:mm"
                value={formDateData.t0}
                onChange={(e) => {
                  handleFormData(e, 't0');
                }}
              />

              <DateTimePicker
                sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                label={textPool['Bitiş Tarihi']}
                ampm={false}
                slotProps={{ textField: { size: 'small' } }}
                inputFormat="dd/MM/yyyy hh:mm"
                value={formDateData.t1}
                onChange={(e) => handleFormData(e, 't1')}
                minDate={formDateData.endDate}
                minTime={formDateData.endDate}
                maxDate={Date.now()}
                maxTime={Date.now()}
                disableIgnoringDatePartForTimeValidation
              />
              <Button
                startIcon={<MATERIEL_ICONS.FileDownload />}
                sx={{ [theme.breakpoints.down('md')]: { width: '100%' } }}
                disabled={isLoading}
                className="mr-1"
                variant="contained"
                onClick={() => {
                  getAllTransportationDataForExcel();
                }}
              >
                {textPool['Dışa Aktar']}{' '}
                {isLoading && (
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      className="w-4 h-4 mx-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span className="sr-only">{textPool['Loading...']}</span>
                  </div>
                )}
              </Button>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center w-[1324px] my-5">
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className="w-full bg-white rounded-xl shadow-xl p-4 mx-4 my-6 ">
                  <DataGrid
                    rows={allTransportation}
                    columns={columns}
                    sortModel={sortModel}
                    setSortModel={setSortModel}
                  />
                  <div className="flex justify-center items-center ">
                    <Pagination
                      page={page + 1}
                      onChange={paginationChange}
                      count={count}
                      color="primary"
                      size="small"
                    />
                  </div>
                </div>
                <div
                  id="map"
                  className="bg-white rounded-xl shadow-xl p-4 mx-4 my-6 w-full  "
                >
                  <MapContainer
                    attributionControl={false}
                    style={{
                      width: '100%',
                      height: '700px',
                    }}
                    center={[37.87244919634651, 32.49206387333341]}
                    zoom={13}
                    scrollWheelZoom={true}
                  >
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    <Centerer />

                    {locations?.length > 0 && (
                      <>
                        <Marker
                          position={locations[0][0]}
                          icon={L.icon({
                            iconUrl: StartIcon,
                            iconSize: [50, 50],
                            iconAnchor: [25, 50],
                          })}
                        />

                        <Polyline
                          pathOptions={{
                            color: '#314663',
                            weight: 4,
                            smoothFactor: 0.5,
                          }}
                          positions={
                            locations.map((item) => [item[0][0], item[0][1]]) ||
                            []
                          }
                        />
                        <Marker
                          position={locations[locations.length - 1][0]}
                          icon={L.icon({
                            iconUrl: EndIcon,
                            iconSize: [50, 50],
                            iconAnchor: [25, 50],
                          })}
                        />
                      </>
                    )}
                  </MapContainer>
                </div>
              </>
            )}
          </>
        </div>
      </div>
    </FullLayout>
  );
}

export default CardEvents;
